export class TechAchatFNS {

	public catalogueElec: string;

	public sad: string;

	public enchereElec: string;

	public accordCadre: string;

	public concours: string;

	public autres: string;

	public sysQuali: string;

	constructor() { 
		 		this.catalogueElec = '';
		this.sad = '';
		this.enchereElec = '';
		this.accordCadre = '';
		this.concours = '';
		this.autres = '';
		this.sysQuali = '';
 
	}
}
